module.exports = __webpack_public_path__ + "img/197.b21649b2.jpg";